type SectionHeadingProps = {
  kicker: string;
  title: string;
  description?: string;
  linkHref?: string;
  linkLabel?: string;
  tone?: 'light' | 'dark';
};

export default function SectionHeading({
  kicker,
  title,
  description,
  linkHref,
  linkLabel,
  tone = 'light',
}: SectionHeadingProps) {
  const isDark = tone === 'dark';

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-3xl">
        <p
          className={`kicker-line text-[11px] font-medium uppercase tracking-[0.28em] ${
            isDark ? 'text-accent-300' : 'text-primary-600'
          }`}
        >
          {kicker}
        </p>
        <h2
          className={`mt-3 font-heading text-2xl font-bold leading-snug tracking-tight md:text-[34px] ${
            isDark ? 'text-background-50' : 'text-foreground-950'
          }`}
        >
          {title}
        </h2>
        {description ? (
          <p className={`mt-3 text-sm leading-relaxed md:text-[15px] ${isDark ? 'text-foreground-300' : 'text-foreground-600'}`}>
            {description}
          </p>
        ) : null}
      </div>
      {linkHref && linkLabel ? (
        <a
          href={linkHref}
          className={`group inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium transition-colors ${
            isDark ? 'text-accent-300 hover:text-accent-100' : 'text-primary-600 hover:text-primary-700'
          }`}
        >
          <span>{linkLabel}</span>
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" />
        </a>
      ) : null}
    </div>
  );
}